import { cn } from "../../../lib/utils"

export interface IndeterminateProgressBarProps {
  isPaused?: boolean
}

export function IndeterminateProgressBar({ isPaused = false }: IndeterminateProgressBarProps) {
  return (
    <div className="relative h-2 w-full overflow-hidden rounded-full bg-primary/10" aria-hidden="true">
      {isPaused ? (
        <span className="absolute inset-y-0 left-1/2 w-1/3 -translate-x-1/2 rounded-full bg-muted-foreground/35" />
      ) : (
        <span
          className={cn(
            "absolute inset-y-0 w-1/3 rounded-full bg-gradient-to-r from-transparent via-primary/80 to-transparent",
            "motion-safe:animate-[job-activity-shimmer_1.4s_ease-in-out_infinite]",
            "motion-reduce:left-1/3 motion-reduce:w-1/3 motion-reduce:-translate-x-1/2 motion-reduce:animate-none motion-reduce:opacity-70",
          )}
        />
      )}
    </div>
  )
}
